// extracted by mini-css-extract-plugin
export default {"cards":"skills_cards__vZcR4","card":"skills_card__C6S3a","cardborder":"skills_cardborder__tUauo","cardcontent":"skills_cardcontent__i9jXd"};